import FileSaver from 'file-saver'

export default {
  install(Vue) {
    Vue.prototype.$fileSaver = async function(data, fileType, fileName) {
      const blob = new Blob(
        [ new Uint8Array(data) ],
        { type: fileType }
      )

      FileSaver.saveAs(blob, fileName)
    }
  }
}
